<script>
import Layout from '@layouts/main.vue'
import { logMethods, logComputed, userMethods } from '@state/helpers'
import dayjs from 'dayjs'

export default {
  page: {
    title: 'Savanorio veiksmų žurnalas',
  },

  components: { Layout },

  data() {
    return {
      fullName: '',
      title: '',
      id: '',
      page: 1,
      perPage: 25,
    }
  },

  computed: {
    ...logComputed,

    userId() {
      return this.$route.params.id
    },
  },

  created() {
    this.viewUser(this.userId)
      .then(
        ({ first_name, last_name }) =>
          (this.fullName = `${first_name} ${last_name}`),
      )
      .catch(() => this.$router.push({ name: 'users' }))
    this.loadLogList()
  },

  methods: {
    ...logMethods,

    ...userMethods,

    loadLogList() {
      const { page, perPage } = this
      this.fetchAllLogs({ userId: this.userId, page, perPage })
    },

    confirmLogDelete(id) {
      if (confirm('Ar tikrai norite ištrinti įrašą?')) {
        this.deleteLog({ userId: this.userId, id }).then(this.loadLogList)
      }
    },

    onSubmitNewLog() {
      if (!this.title) {
        return
      }

      if (this.id) {
        this.updateLog({
          userId: this.userId,
          id: this.id,
          title: this.title,
        })
          .then(this.loadLogList)
          .then(() => {
            this.title = ''
            this.id = null
          })
      } else {
        this.createLog({ userId: this.userId, title: this.title })
          .then(this.loadLogList)
          .then(() => {
            this.title = ''
            this.id = null
          })
      }
    },

    changeLogEntry(log) {
      this.title = JSON.parse(log.details).title
      this.id = log.id
    },

    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:MM')
    },

    titletizeLog(log) {
      const details = JSON.parse(log.details)
      switch (log.category) {
        case 'user.create':
          return `Sukūrė savanorio profilį ${details.first_name} ${details.last_name} <${details.email}>`
        case 'user.update':
          return `Atnaujino savanorio profilį ${details.first_name} ${details.last_name} <${details.email}>`
        case 'user.delete':
          return `Pašalino savanorio profilį ${details.first_name} ${details.last_name} <${details.email}>`
        case 'kid.create':
          return `Sukūrė vaiko profilį ${details.first_name}`
        case 'kid.update':
          return `Atnaujino vaiko profilį ${details.first_name}`
        case 'kid.delete':
          return `Pašalino vaiko profilį ${details.first_name}`
        case 'volunteer_duty.create':
          return `Prisidėjo sau galimybę ${details.date} datai`
        case 'volunteer_duty.d':
          return `Prisidėjo sau galimybę ${details.date} datai`
        case 'volunteer_duty.delete':
          return `Pašalino savo galimybę ${details.date} datai`
        case 'duty.create':
          return `Priskyrė galimybę: ${details.first_name} (${details.date} datai)`
        case 'duty.update':
          return `Atnaujino galimybę: ${details.first_name} (${details.date} datai)`
        case 'duty.delete':
          return `Pašalino galimybę: ${details.first_name} (${details.date} datai)`
        case 'volunteer.create':
          return `Pridėjo savanorį ${details.first_name} į grafiką`
        case 'volunteer.update':
          return `Pakeitė grafiko savanorį į ${details.first_name}`
        case 'volunteer.delete':
          return `Pašalino savanorį ${details.first_name} iš grafiko`
      }
    },

    changePage(page) {
      this.page = page

      this.loadLogList()
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <h1 class="text-2xl font-bold"> {{ fullName }}: veiksmų žurnalas </h1>
      </template>
      <template v-slot:actions>
        <div>
          <base-btn
            class="lg:ml-2 py-2 px-4"
            @click="$router.push({ name: 'user-edit', params: { id: userId } })"
          >
            <font-awesome-icon :icon="['fas', 'undo']" class="mr-1" />
            Grįžti atgal
          </base-btn>
        </div>
      </template>
    </base-page-title>

    <div class="mb-4">
      <base-label-input
        v-model="title"
        type="text"
        label="Naujas žurnalo įrašas"
        required
        placeholder="Komentaras..."
        @submit="onSubmitNewLog"
      />
    </div>

    <div class="-mx-8">
      <table v-if="logs && logs.length" class="table-auto w-full">
        <thead>
          <tr>
            <th class="text-left">Įrašas</th>
            <th class="hidden lg:table-cell">Data</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in logs" :key="log.id" class="border text-sm">
            <td>
              <div>
                <a
                  v-if="log.category === 'manual'"
                  @click="changeLogEntry(log)"
                >
                  {{ JSON.parse(log.details).title }}
                </a>
                <span v-else>
                  {{ titletizeLog(log) }}
                </span>
              </div>
              <div class="block lg:hidden text-xs mt-2">
                {{ formatDate(log.created_at) }}
              </div>
            </td>
            <td class="w-64 hidden lg:table-cell">
              {{ formatDate(log.created_at) }}
            </td>
            <td class="w-32">
              <base-btn
                v-if="log.category === 'manual'"
                type="danger"
                class="ml-2 px-2 py-1"
                @click="confirmLogDelete(log.id)"
              >
                Pašalinti
              </base-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <base-pagination :pagination="logsPagination" @change="changePage" />
  </Layout>
</template>
